import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { DocumentFolderTreeComponent } from 'src/app/components/document-folder-tree/document-folder-tree.component';
import { ModalComponent } from 'src/app/components/modal/modal.component';
import { TreeNode } from 'src/app/models/template.model';
import { CommonService } from 'src/app/services/common.service';
import { ModalService } from 'src/app/services/modal.service';

import { DocumentTemplateService } from './document-template.service';
@Component({
  selector: 'app-document-template',
  templateUrl: './document-template.component.html',
  styleUrls: ['./document-template.component.scss'],
  standalone: true,
  providers: [ModalService],
  imports: [CommonModule, ModalComponent, FormsModule, ReactiveFormsModule, TranslateModule, DocumentFolderTreeComponent],
})
export class DocumentTemplateComponent {
  templates: TreeNode[] = [];
  subscription?: Subscription;
  constructor(private documentTemplateService: DocumentTemplateService, public commonService: CommonService) {
    this.subscription = this.commonService.isDocumentTemplateSelected.subscribe((res) => {
      if (res) {
        this.loadTemplates();
      }
    });
  }

  loadTemplates(): void {
    this.documentTemplateService.loadTemplates().subscribe({
      next: (res: any) => {
        const categories = res.map((item: any) => ({
          type: 'folder',
          label: item.name,
          data: item.id,
          expanded: true,
          children: [],
          selectable: false,
        }));
        this.documentTemplateService.loadTemplateChilds().subscribe({
          next: (res: any) => {
            const tmpResults = categories;
            for (let i = 0; i < res.length; i++) {
              const template = res[i];
              const category = tmpResults.find((item: any) => item.data === template.categoryId);
              const { name } = template;

              if (!template.hasContent) {
                continue;
              }
              category.children.push({
                type: 'file',
                label: name,
                data: template.id,
              });
            }

            this.templates = <TreeNode[]>tmpResults.sort(function (a: { label: number; labellabel: number }, b: { label: number }) {
              return a.label > b.label ? 1 : b.label > a.labellabel ? -1 : 0;
            });
          },
        });
      },
      error: () => {},
    });
  }

  getSelectedFolderHiearachy(): any {
    this.commonService.getSelectedTemplate();
  }
}
